const rsc = JSON.parse(localStorage.getItem("rsc"));
let e_code, r_stage
if (rsc) {
  e_code = rsc.e_code;
  r_stage = rsc.r_stage;
}

export const getECode = e_code;

export const getRStage = r_stage;

export const getToken = localStorage.getItem("token");

export const getRsc = JSON.parse(localStorage.getItem("rsc"));

export function stageParser(r_stage) {
  switch(r_stage) {
    case "0":
      return "test12"
    case "1":
      return "production"
    case "8":
      return "staging"
    case "9":
      return "development"
    case "nil":
      return ""
    default:
      return "development"
  }
}
